// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HknwC","icon":"styles_icon__4i4AZ","content":"styles_content__9Nf9J","warning":"styles_warning__EQp8o","error":"styles_error__XbYbn"};